export default "__VITE_ASSET__B1KzMP7R__"